import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import FAQ from '@/components/base/FAQ';
import { faqs } from '@/mocks/faqs';
import Hero from './components/Hero';
import Features from './components/Features';
import Stats from './components/Stats';
import Cases from './components/Cases';
import ContentHub from './components/ContentHub';
import CTA from './components/CTA';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Stats />
        <Cases />
        <ContentHub />

        <section className="py-16 md:py-20 bg-background-50">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
                常见问题
              </h2>
              <p className="text-foreground-500">关于磁力金牛，你想知道的都在这里</p>
            </div>
            <FAQ items={faqs} />
          </div>
        </section>

        <CTA />
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '磁力金牛——强力吸金的财富增长利器',
        description: '磁力金牛是专为追求稳定收益与爆发式增长的用户打造的核心财富管理工具',
      }) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((f) => ({
          '@type': 'Question',
          name: f.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: f.answer,
          },
        })),
      }) }} />
    </>
  );
}